import { logger } from '@helpers/logger' // Updated to use the new log structure
import { getRequest } from '@helpers/request'

// Cache to hold ongoing requests
const requestCache = new Map()

// Function to fetch sport database events
export const getSportDbEvents = async (sport, leagueId, leagueName, season) => {
  const params = { sport, season, leagueId, leagueName } // Define parameters for logging

  const logComplete = logger.serviceRequest('getSportDbEvents', params) // Log service request

  const cacheKey = `${sport}-${leagueName}-${season}` // Unique key for caching requests

  // Check if there's already a pending promise for this request
  if (requestCache.has(cacheKey)) {
    logComplete(true) // Log as cached request
    return requestCache.get(cacheKey) // Return the pending promise
  }

  const requestPromise = (async () => {
    try {
      const { response, logComplete: requestLogComplete } = await getRequest('sportDbEvents', params)
      logger.log('getSportDbEvents response:', response)

      // Extract events from response
      const events = response?.events || []

      requestLogComplete() // Call the completion logging function
      return events
    } catch (error) {
      logger.error('getSportDbEvents', error)
      logComplete() // Call the completion logging function even on error
      return []
    } finally {
      // Clean up the cache
      requestCache.delete(cacheKey)
    }
  })()

  // Cache the promise
  requestCache.set(cacheKey, requestPromise)
  return requestPromise // Return the promise
}
